"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewTarget = void 0;
var ReviewTarget;
(function (ReviewTarget) {
    ReviewTarget[ReviewTarget["AfterVideo"] = 0] = "AfterVideo";
    ReviewTarget[ReviewTarget["Default"] = 1] = "Default";
    ReviewTarget[ReviewTarget["DayTrip"] = 2] = "DayTrip";
})(ReviewTarget || (exports.ReviewTarget = ReviewTarget = {}));
//# sourceMappingURL=ReviewTarget.js.map